<template>
  <Teleport to="body">
    <!-- titan-remote-scope: teleported to the host's <body> when embedded,
         outside the custom elements — the class re-attaches the remote's
         typography and design tokens (see src/remote/embedded.css). -->
    <div
      v-if="topRight.length"
      class="titan-remote-scope tw-absolute tw-right-10 tw-top-10 tw-z-[55] tw-flex tw-flex-col-reverse tw-gap-2"
      data-test-id="toasts-top-right"
    >
      <cl-toast
        v-for="toast in topRight"
        :id="toast.id"
        :key="toast.id"
        :title="toast.title"
        :message="toast.message ?? ''"
        :variant="toast.variant"
        :test-id="toast.testId"
        @on-close="closeToast(toast.id)"
      >
        <component
          :is="toast.slotComponent"
          v-if="toast.slotComponent"
          v-bind="{ ...toast.slotProps, toastId: toast.id }"
        />
      </cl-toast>
    </div>
    <div
      v-if="bottomRight.length"
      class="titan-remote-scope tw-fixed tw-bottom-6 tw-right-6 tw-z-[55] tw-flex tw-flex-col tw-gap-3 max-[420px]:tw-left-4 max-[420px]:tw-right-4"
      data-test-id="toasts-bottom-right"
    >
      <cl-toast
        v-for="toast in bottomRight"
        :id="toast.id"
        :key="toast.id"
        :title="toast.title"
        :message="toast.message ?? ''"
        :variant="toast.variant"
        :test-id="toast.testId"
        @on-close="closeToast(toast.id)"
      >
        <component
          :is="toast.slotComponent"
          v-if="toast.slotComponent"
          v-bind="{ ...toast.slotProps, toastId: toast.id }"
        />
      </cl-toast>
    </div>
  </Teleport>
</template>
<script lang="ts" setup>
import { computed } from "vue";
import { useToastStore } from "./toast.store";

const store = useToastStore();
const topRight = computed(() =>
  store.toasts.filter(
    (toast) => (toast.position ?? "top-right") === "top-right",
  ),
);
const bottomRight = computed(() =>
  store.toasts.filter((toast) => toast.position === "bottom-right"),
);

const closeToast = (id: string) => store.closeToast(id);
</script>
